import React from "react";

export const HEADER_ROW = "var(--color-p2)";
export const ROW_BORDER = "1px solid #dee2e6";

export const labelStyle: React.CSSProperties = {
  fontSize: "0.72rem",
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: "#374151",
  fontWeight: 700,
  marginBottom: "4px",
  display: "block",
};

export const BTN_STYLE: React.CSSProperties = {
  fontSize: "0.875rem",
  whiteSpace: "nowrap",
};

export const thBase: React.CSSProperties = {
  color: "#ffffff",
  fontWeight: 600,
  padding: "10px 10px",
  border: "none",
  backgroundColor: HEADER_ROW,
  fontSize: "0.8125rem",
  verticalAlign: "bottom",
};
export const thLeft: React.CSSProperties = { ...thBase, textAlign: "left" };
export const thCenter: React.CSSProperties = {
  ...thBase,
  textAlign: "center",
  whiteSpace: "nowrap",
  padding: "10px 6px",
};

export const tdBase: React.CSSProperties = {
  padding: "10px 10px",
  borderBottom: ROW_BORDER,
  fontSize: "0.8125rem",
  color: "#0f1923",
  fontWeight: 500,
  verticalAlign: "middle",
};
export const tdCenter: React.CSSProperties = {
  ...tdBase,
  textAlign: "center",
  padding: "10px 6px",
};
export const tdWrap: React.CSSProperties = {
  ...tdBase,
  wordBreak: "break-word",
  overflowWrap: "anywhere",
};
export const nowrapSpan: React.CSSProperties = { whiteSpace: "nowrap" };

export const tdTotalLabel: React.CSSProperties = {
  ...tdBase,
  fontWeight: 700,
  borderTop: `2px solid ${HEADER_ROW}`,
  borderBottom: "none",
};
